import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { TaskDocument } from '../model/task-document';

@Injectable({
    providedIn: 'root'
  })
  export class TaskDocumentService{
  
    constructor(private _restClientService : RestClientService) { }
    
    
    getTaskDocumentsByTaskworkflowId(taskworflowid)
    {
        return this._restClientService.load<TaskDocument[]>('task-document/task-document-by-taskworflowid/'+taskworflowid);
    }
  
    add(document) {
        return  this._restClientService.save<TaskDocument>('task-document/add-task-document', document);
    }
       
    update(document) {
        return  this._restClientService.put<TaskDocument>(`task-document/update-task-document`, document);
    }
      
    getTaskDocumentById(documentId)
    {
        return this._restClientService.load<TaskDocument>('task-document/task-document-by-id/'+documentId);
    }
        
    delete(documentId) 
    {
        return this._restClientService.delete<any>('task-document/delete-task-document/'+documentId);
    }
  
    getTaskDocumentsNotUploadedByTaskId(taskid)
    {
        return this._restClientService.load<TaskDocument[]>('task-document/task-documents-not-uploaded?taskid='+taskid);
    }
  
    getTaskDocumentsByTaskId(taskid)
    {
        return this._restClientService.load<TaskDocument[]>('task-document/task-documents-by-taskid?taskid='+taskid);
    }
  

        
        
        


}      

    